import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import styles from "./ShareContent.module.scss";

export const ShareContent = ({
  shareUrl,
  title,
}: {
  shareUrl: string;
  title: string;
}) => (
  <div className={styles.share}>
    Help us raise more money for charities by sharing this page ♥️
    {/* Share this content with your friends and help us raise more money
            for charities ♥️ */}
    <div className={styles.shareButtons}>
      <FacebookShareButton
        url={shareUrl}
        quote={title}
        className={styles.shareButton}
      >
        <FacebookIcon size={48} round />
      </FacebookShareButton>
      {/* <FacebookMessengerShareButton
            
          >
              <FacebookMessengerIcon size={48} round />
            </FacebookMessengerShareButton> */}

      <TwitterShareButton url={shareUrl} title={title}>
        <TwitterIcon size={48} round />
      </TwitterShareButton>

      <TelegramShareButton url={shareUrl} title={title}>
        <TelegramIcon size={48} round />
      </TelegramShareButton>

      <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
        <WhatsappIcon size={48} round />
      </WhatsappShareButton>

      <LinkedinShareButton url={shareUrl} title={title}>
        <LinkedinIcon size={48} round />
      </LinkedinShareButton>

      <EmailShareButton url={shareUrl} subject={title}>
        <EmailIcon size={48} round />
      </EmailShareButton>
    </div>
  </div>
);
